<mat-toolbar class="mat-toolbar-azul">
  <img [src]="logoVisorWeb" width="200vw" height="auto" fxHide.xs>
  <span class="text-container">Referencia {{reference}} - {{ description }}</span>
  <button mat-icon-button (click)="closeDialogSpecification()" class="menu-button">
    <mat-icon matSuffix>close</mat-icon>
  </button>
</mat-toolbar>
<div>
  <div mat-dialog-content class="mat-dialog-information-message div-conten-justify">
    <p style="margin: 0.5vw;">{{ specification }}</p>
  </div>
</div>
